import script from "./CartChoosePaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./CartChoosePaymentMethod.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__